/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  // GET_NOTIFICATIONS, MARK_NOTI_AS_COMPLETED, ADD_NOTIFICATION,
  GET_REMINDERS,
  ADD_REMINDER,
  UPDATE_REMINDER,
} from "../actionTypes";

export const getRemindersList = (dispatch) => {
  dispatch({
    type: GET_REMINDERS,
  });
};

export const updateReminder = (remId, dispatch) => {
  dispatch({
    type: UPDATE_REMINDER,
    payload: remId,
  });
};

export const addReminder = (data, dispatch) => {
  dispatch({
    type: ADD_REMINDER,
    payload: data,
  });
};
